module.exports = __webpack_public_path__ + "static/media/deep-aws.c1b1557f.png";